import { selectUserId } from '../reducers/user/userSelectors';

const getCategoryFromAction = ({ type }) =>
  type.substring(type.indexOf('[') + 1, type.indexOf(']'));
const getNameFromAction = ({ type }) =>
  type.substring(type.indexOf('(') + 1, type.indexOf(')'));
const getLabelFromAction = ({ type }) =>
  type.substring(type.indexOf(')') + 1, type.length).trim();

const event = (action, { getState }) => {
  const name = getNameFromAction(action);
  const event = `mgmw.${name}`;
  const category = getCategoryFromAction(action);
  const label = getLabelFromAction(action);
  const userId = selectUserId(getState());

  return { event, category, name, label, userId };
};

const registerEvent = (action, store) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(event(action, store));
};

const sendGtagEvent = ({ name, params }) => {
  if (typeof window.gtag !== 'function') return;
  try {
    window.gtag('event', name, params);
  } catch {
    console.warn(`Analytics event "${name}" failed`);
  }
};

const AnalyticsMiddleware = store => next => action => {
  // Only register events with a '(' to determine if that action has an event name.
  if (action.type && action.type.includes('(')) registerEvent(action, store);
  if (action.meta && action.meta.gtag) sendGtagEvent(action.meta.gtag);
  return next(action);
};

export default AnalyticsMiddleware;
